// extracted by mini-css-extract-plugin
export default {"coa-table":"Coa_coa-table__Ecdvx","coa-table__action":"Coa_coa-table__action__jis8R","coa-table__action--button":"Coa_coa-table__action--button__FBj7r"};